var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { required } from "@frameworks/web/utils/validation";
import "@frameworks/shared-library/stylesheets/components/TextAreaField.scss";
var TextAreaField = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(React.useState(""), 2), focusClass = _e[0], setFocusClass = _e[1];
    var _f = __read(React.useState(props.defaultValue || ""), 2), value = _f[0], setValue = _f[1];
    function isRequired(value) {
        return !props.required || (props.required && !!required(value));
    }
    function isValidMaxLength(value) {
        return (!props.maxLength || (props.maxLength && (value === null || value === void 0 ? void 0 : value.length) > props.maxLength));
    }
    function isValidMinLength(value) {
        return (!props.minLength || ((props === null || props === void 0 ? void 0 : props.minLength) && (value === null || value === void 0 ? void 0 : value.length) < props.minLength));
    }
    function handleBlur(e) {
        setFocusClass("");
        var errorObj = {};
        if (props.required) {
            errorObj = __assign(__assign({}, errorObj), { required: isRequired(value) });
        }
        if (props === null || props === void 0 ? void 0 : props.minLength) {
            errorObj = __assign(__assign({}, errorObj), { minLength: isValidMinLength(value) });
        }
        if (props === null || props === void 0 ? void 0 : props.maxLength) {
            errorObj = __assign(__assign({}, errorObj), { maxLength: isValidMaxLength(value) });
        }
        props.onBlur(errorObj, e);
    }
    React.useEffect(function () {
        if (props.defaultValue !== undefined && value !== props.defaultValue) {
            setValue(props.defaultValue);
        }
    }, [props.defaultValue]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: "text-area-field " + props.className },
                React.createElement("div", { className: props.placeholderClassName +
                        (props.errorText ? " error" : focusClass) }, value === "" && props.label && (React.createElement(React.Fragment, null,
                    React.createElement("label", { htmlFor: props.id }, props.placeholder),
                    props.required && React.createElement("span", { className: "star" }, "*")))),
                React.createElement("div", { className: "position-relative text-area-container" },
                    React.createElement("textarea", { defaultValue: props.defaultValue, value: props === null || props === void 0 ? void 0 : props.value, onChange: props.onChangeEvent, placeholder: props.label ? "" : props.placeholder, className: "form-control", id: props.id, minLength: (_a = props === null || props === void 0 ? void 0 : props.minLength) !== null && _a !== void 0 ? _a : 10000, maxLength: (_b = props === null || props === void 0 ? void 0 : props.maxLength) !== null && _b !== void 0 ? _b : 10000, name: props.name, required: props.required, onFocus: function () { return setFocusClass(" focus"); }, onBlur: function (e) { return handleBlur(e); } }),
                    (props === null || props === void 0 ? void 0 : props.minLength) && (React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey text-end char-counter position-absolute" }, (_c = props === null || props === void 0 ? void 0 : props.defaultValue) === null || _c === void 0 ? void 0 : _c.length)),
                    (props === null || props === void 0 ? void 0 : props.maxLength) && (React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey text-end char-counter position-absolute" }, (_d = props === null || props === void 0 ? void 0 : props.defaultValue) === null || _d === void 0 ? void 0 :
                        _d.length,
                        "/", props === null || props === void 0 ? void 0 :
                        props.maxLength))),
                React.createElement("div", { className: "d-flex align-items-center justify-content-between flex-row-reverse" },
                    React.createElement("div", { className: "d-flex align-items-center  text-start w-100" }, props.errorText && (React.createElement("span", { className: "help_text red text-start" }, props.errorText))))))));
};
export default TextAreaField;
